module.exports = {
	"id": "MK",
	"name": "Macedonia",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": 0.027532,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": 0.013766,
			"19": 0.006883,
			"20": null,
			"21": null,
			"22": 0.075713,
			"23": null,
			"24": null,
			"25": null,
			"26": 0.055064,
			"27": 0.006883,
			"28": 0.006883,
			"29": 0.013766,
			"30": 0.013766,
			"31": 0.027532,
			"32": 0.020649,
			"33": 0.034415,
			"34": 0.089479,
			"35": 0.027532,
			"36": 0.06883,
			"37": 0.048181,
			"38": 0.06883,
			"39": 0.06883,
			"40": 0.034415,
			"41": 0.013766,
			"42": 0.034415,
			"43": 0.165192,
			"44": 0.06883,
			"45": 0.034415,
			"46": 0.041298,
			"47": 0.199607,
			"48": 0.103245,
			"49": 4.756153,
			"50": 0.13766,
			"51": 0.942971,
			"52": 0.433629,
			"53": 32.226206,
			"54": 9.505423,
			"55": 0.158309,
			"56": 0.027532,
			"57": null
		},
		"firefox": {
			"2": 0.020649,
			"3": 0.006883,
			"4": null,
			"5": 0.013766,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": null,
			"12": 0.013766,
			"13": 0.075713,
			"14": 0.006883,
			"15": null,
			"16": 0.006883,
			"17": 0.123894,
			"18": 0.006883,
			"19": null,
			"20": 0.013766,
			"21": 0.013766,
			"22": null,
			"23": 0.006883,
			"24": 0.027532,
			"25": null,
			"26": 0.013766,
			"27": null,
			"28": null,
			"29": 0.034415,
			"30": 0.020649,
			"31": 0.020649,
			"32": 0.006883,
			"33": 0.006883,
			"34": null,
			"35": 0.020649,
			"36": 0.034415,
			"37": 0.020649,
			"38": 0.13766,
			"39": 0.027532,
			"40": 0.020649,
			"41": 0.041298,
			"42": 0.041298,
			"43": 0.151426,
			"44": 0.048181,
			"45": 0.117011,
			"46": 0.103245,
			"47": 0.585055,
			"48": 0.447395,
			"49": 8.059993,
			"50": 0.144543,
			"51": null,
			"52": null,
			"3.5": null,
			"3.6": 0.13766
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": 0.089479,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": 0.013766,
			"29": null,
			"30": 0.006883,
			"31": 0.013766,
			"32": null,
			"33": null,
			"34": 0.020649,
			"35": null,
			"36": 0.20649,
			"37": 0.020649,
			"38": 0.096362,
			"39": 0.034415,
			"40": 0.881024,
			"41": 0.165192,
			"42": 0.006883,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": 0.006883,
			"12.1": 0.055064
		},
		"safari": {
			"0": null,
			"4": 0,
			"5": 0.006883,
			"6": null,
			"7": 0.006883,
			"8": 0.027532,
			"9": 0.034415,
			"10": 0.234022,
			"3.1": null,
			"3.2": null,
			"5.1": 0.041298,
			"6.1": 0.013766,
			"7.1": null,
			"9.1": 0.117011
		},
		"ios_saf": {
			"8": 0,
			"10": 3.33465795587,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.0898651732931,
			"8.1-8.4": 0.166022099813,
			"9.0-9.2": 0.0792032035803,
			"9.3": 1.20835656744
		},
		"android": {
			"3": 0,
			"4": 0.0507418604651,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.00634273255814,
			"4.1": 0.183033139535,
			"4.2-4.3": 0.457582848837,
			"4.4": 1.04926918605,
			"4.4.3-4.4.4": 1.05833023256
		},
		"ie": {
			"6": null,
			"7": 0.0279870743802,
			"8": 0.258880438017,
			"9": 0.0909579917355,
			"10": 0.104951528926,
			"11": 1.21044096694,
			"5.5": null
		},
		"op_mob": {
			"0": 0.0182713080415,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.000507536334485
		},
		"edge": {
			"12": 0.048181,
			"13": 0.178958,
			"14": 0.488693
		},
		"ie_mob": {
			"10": 0.0995683943662,
			"11": 0.405385605634
		},
		"bb": {
			"7": 0.009351,
			"10": null
		},
		"samsung": {
			"0": 1.997997
		},
		"and_uc": {
			"0": 0.102861
		},
		"op_mini": {
			"0": 0.246166155624
		},
		"and_chr": {
			"0": 23.051753
		},
		"and_ff": {
			"0": 0.015585
		}
	},
	"total": 98.275987
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/MK.json
 ** module id = 588
 ** module chunks = 0
 **/